import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

import { ProblemDetails } from '../../shared/models/problem-details.model';

/**
 * Normalizes every failed API response into the shared ProblemDetails shape and logs it
 * with its traceId, so a support conversation ("it errored") can be tied back to a
 * specific backend log entry. Toast/notification presentation is added once the
 * Notifications module exists (Sprint 6) -- this is the parsing/logging foundation only.
 */
export const problemDetailsInterceptor: HttpInterceptorFn = (request, next) =>
  next(request).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && isProblemDetails(error.error)) {
        const problem = error.error as ProblemDetails;
        console.error(`[${problem.errorCode ?? 'UNKNOWN_ERROR'}] ${problem.title} (traceId: ${problem.traceId})`);
      }

      return throwError(() => error);
    }),
  );

function isProblemDetails(value: unknown): value is ProblemDetails {
  return typeof value === 'object' && value !== null && 'title' in value;
}
